import { Resource } from "src/app/core/jsonapi/resource";
import { prop, required } from "@rxweb/reactive-form-validators";
import { File } from "../../common/_types/file";

export class WorkerSeizure extends Resource {
    public override type = 'workerSeizures';

    @prop()
    @required()
    public workerId?: string;

    @prop()
    public date: Date = new Date();

    @prop()
    public ammount?: number;

    @prop()
    public caseNumber?: string;

    @prop()
    public isClosed: boolean = false;

    @prop()
    public caseFileId?: string;
        public caseFile!: File;

    @prop()
    public closedDate?: Date;
    
    @prop()
    public closedCaseFileId?: string;
    public closedCaseFile!: File;
}